module.exports = __webpack_public_path__ + "static/media/CUIDADO_Y_CONTROL_AMBIENTAL.5e755603.png";